// extracted by mini-css-extract-plugin
export default {"Container":"Container_Container__8y2gF"};